<template>
  <DialogTutorialBase :delay-button="800" v-bind="props">
    <template #title>
      🔥 Bravo <strong>{{ user.firstname || profile.displayName }}</strong>
    </template>
    <DomFade :delay="10">
      Tu as choisi <strong>la meilleure façon de tout exploser</strong> cette
      année, bienvenue ! 🏄‍♀️
    </DomFade>
    <DomFade :delay="100"> <strong> 3 conseils pour toi… </strong></DomFade>
  </DialogTutorialBase>
</template>
<script lang="ts" setup>
interface Props {
  onNext: Function;
}
const props = defineProps({
  onNext: { type: Function }
});
const profile = useProfileStore();
const user = useUserStore();
</script>
<style lang="scss" scoped></style>
